import React from 'react';
import {Box, CloseButton, Flex, Image, Text} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useScoringRun} from '../../../context/ScoringRunContext';
import {AccountWithLogo} from '../../../shared/scoredAccounts';
import {FilterSelect} from './FilterSelect';

const filterSelectionOptions = {
  include: {label: 'include any of', value: 'include any of'},
};

export const SimilarAccountsFilterControl = ({
  similarTo,
  setSimilarTo,
  onRemove,
}: {
  similarTo: ObjectId[];
  setSimilarTo: (similarTo: ObjectId[]) => void;
  onRemove?: () => void;
}) => {
  const scoringRun = useScoringRun();
  const lookalikesWithLogos = scoringRun?.lookalikesWithLogos;
  const selectedSimilarTo = lookalikesWithLogos?.filter((lookalike) =>
    similarTo.find((id) => id.equals(lookalike._id))
  );

  if (!lookalikesWithLogos) {
    return null;
  }

  return (
    <Flex gap="2" flex={2} alignItems="center">
      <FilterSelect
        variant="operator"
        options={Object.values(filterSelectionOptions)}
        value={filterSelectionOptions.include}
      />

      <FilterSelect
        noOptionsMessage={() => 'No similar accounts.'}
        options={lookalikesWithLogos?.map((lookalike) => ({
          value: lookalike,
          label: lookalike.name,
        }))}
        isMulti
        formatOptionLabel={formatLookalikeOptionLabel}
        value={selectedSimilarTo?.map((lookalike) => ({
          value: lookalike,
        }))}
        onChange={(values) => setSimilarTo(values.map((v) => v.value._id))}
      />
      <CloseButton onClick={onRemove} />
    </Flex>
  );
};

const formatLookalikeOptionLabel = ({value}: {value: AccountWithLogo}) => {
  return (
    <Box display="flex" alignItems="center" mt="0">
      <Image
        src={value.logoUrl}
        alt="icon"
        boxSize="24px"
        mr="2"
        fallbackSrc="/accountFallback.png"
      />
      <Text>{value.name}</Text>
    </Box>
  );
};
